export default __webpack_public_path__ + "static/utility-5f7f1c1dce8001c7f16a0fc51021dfa1.png";